const getTopSpots = (state) => state.topSpots.topSpots;

export default getTopSpots;
